import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import moment from "moment-timezone";
import {
  Alert,
  Icon,
  Layout,
  Input,
  Select,
  Table,
  Badge,
  Button,
  Modal,
  Switch,
  message,
  Tooltip,
  Breadcrumb,
} from "antd";

import SettingsSiteForm from "../../components/SettingsSiteForm/SettingsSiteForm";
import classes from "./SettingsSites.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getSettingsSitesRequest,
  getSettingsUsersRequest,
  deleteSiteRequest,
  activateSiteRequest,
  activateSiteRandomizationRequest,
  deleteSiteRandomizationRequest, deleteConsentSiteSpecificRequest, activateConsentSiteSpecificRequest,
  getConsentSettingsRequest,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import {
  getActiveDrugSiteTypes,
  getDrugManagementStatus,
  getSiteCreatePermission,
  getSiteDeletePermission,
  getSiteUpdatePermission,
  getUserShortTimezone,
  getUserTimezone,
} from "../../reducers/user/selectors";
import { withNamespaces } from "react-i18next";

const routes = require("../../routes.json");

const { Content } = Layout;
const { Search } = Input;
const { Option } = Select;

class SettingsSites extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      nameSearch: null,
      sitesList: [],
      errorMessage: "",
      responseMessage: "",
      siteEdit: null,
      sortedInfo: {},
      order: "asc",
      filter: "",
      users: [],
      user: null,
      siteType: null,
      consentSettings: {},
    };
  }

  async componentDidMount() {
    this.getSitesList();
    this.getSitesListSelect();

    try {
      const { data } = await getSettingsUsersRequest({});
      this.setState({ users: data.data });
      this.getConsentSettingsRequest();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
  }

  getConsentSettingsRequest = async () => {
    try {
      const { data } = await getConsentSettingsRequest();
      this.setState({
        consentSettings: data,
      });
    } catch (e) {
      console.log(e);
    }
  };


  onNameSearch = async (value) => {
    this.setState({ nameSearch: value }, this.getSitesList);
  };

  getSitesList = async () => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getSettingsSitesRequest({
        filter_by: this.state.filter,
        user_id: this.state.user,
        site_type: this.state.siteType,
        order_direction: this.state.order,
        order_column: get(this.state, "sortedInfo.columnKey"),
        nameSearch: this.state.nameSearch,
      });
      this.setState({
        sitesList: data,
      });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        subject: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }

    this.setState({ isLoading: false });
  };

  getSitesListSelect = async () => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getSettingsSitesRequest({
        order_direction: this.state.order,
        order_column: get(this.state, "sortedInfo.columnKey"),
      });
      this.setState({
        manufacturerSites: data
          .filter((site) => get(site, "site_type") === "manufacturer")
          .map((site) => ({
            value: get(site, "id"),
            label: get(site, "name"),
          })),
        pharmacySites: data
          .filter((site) => get(site, "site_type") === "pharmacy")
          .map((site) => ({
            value: get(site, "id"),
            label: get(site, "name"),
          })),
        fridgeSites: data
          .filter((site) => get(site, "site_type") === "fridge")
          .map((site) => ({
            value: get(site, "id"),
            label: get(site, "name"),
          })),
        depotSites: data
          .filter((site) => get(site, "site_type") === "depot")
          .map((site) => ({
            value: get(site, "id"),
            label: get(site, "name"),
          })),
      });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        subject: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }

    this.setState({ isLoading: false });
  };

  handleFilterChange = (value) => {
    this.setState(
      { filter: value, user: null, sortedInfo: null },
      this.getSitesList
    );
  };
  handleUserChange = (value) => {
    this.setState({ user: value, sortedInfo: null }, this.getSitesList);
  };
  handleSiteTypeChange = (value) => {
    this.setState({ siteType: value, sortedInfo: null }, this.getSitesList);
  };
  clearFilters = () => {
    this.setState(
      { user: null, filter: null, sortedInfo: null },
      this.getSitesList
    );
  };

  onSwitchSiteActivation = (code, state) => async () => {
    try {
      if (state === "active") {
        await deleteSiteRequest(code);
      } else {
        await activateSiteRequest(code);
      }

      message.success("Saved");

      this.getSitesList();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(get(e, "response.data.error", "Error"));
      console.log(e);
    }
  };

  onSwitchSiteRandomization = (code, state) => async () => {
    try {
      if (state) {
        await deleteSiteRandomizationRequest(code);
      } else {
        await activateSiteRandomizationRequest(code);
      }

      message.success("Saved");

      this.getSitesList();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(get(e, "response.data.error", "Error"));
      console.log(e);
    }
  };

  onSwitchConsentSiteSpecificActivation = (id, state) => async () => {
    try {
      if (state) {
        await deleteConsentSiteSpecificRequest(id);
      } else {
        await activateConsentSiteSpecificRequest(id);
      }

      message.success(this.props.i18n.t('Saved'));

      this.getSitesList();
    } catch (e) {
      if (get(e, 'response.status') === 401) { this.props.logout();  return; }
      message.error(get(e, 'response.data.error', 'Error'));
    }
  };

  onSiteEdit = (site) => () => {
    this.setState({ siteEdit: site });
  };

  onSiteEditHide = () => {
    this.setState({ siteEdit: null });
  };

  onSiteEditSubmit = () => {
    this.setState({ siteEdit: null }, this.getSitesList);
  };

  addSite = () => {
    this.setState({ siteEdit: {} });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      {
        isLoading: true,
        sortedInfo: sorter,
        order:
          get(sorter, "order") === "ascend"
            ? "asc"
            : get(sorter, "order") === "descend"
            ? "desc"
            : "asc",
      },
      () => this.getSitesList()
    );
  };

  render() {
    const {
      sitesList,
      errorMessage,
      responseMessage,
      isLoading,
      siteEdit,
      pharmacySites,
      fridgeSites,
      depotSites,
      manufacturerSites,
      sortedInfo,
      filter,
      user,
      users,
      siteType,
      nameSearch,
    } = this.state;
    const { siteCreatePermission, isDrugManagementActive, activeDrugSiteTypes} = this.props;

    const columns = [
      {
        dataIndex: "code",
        key: "code",
        title: this.props.i18n.t("Site ID"),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "code" && sortedInfo.order,
      },
      {
        dataIndex: "name",
        key: "name",
        title: this.props.i18n.t("NamespaceSettingsSites:Site name"),
        render: (val, record) => (
          <span>
            {val} &nbsp;{" "}
            <Badge
              count={record.state}
              style={{
                backgroundColor: record.state === "active" ? "#52c41a" : "#777",
              }}
            />
          </span>
        ),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "name" && sortedInfo.order,
      },
      {
        dataIndex: "location",
        key: "location",
        title: this.props.i18n.t("Location"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "location" && sortedInfo.order,
      },
      {
        dataIndex: "time_zone",
        key: "time_zone",
        title: this.props.i18n.t("Time zone"),
        render: (val, record) => (
          <span>
            {val} ({record.short_tz})
          </span>
        ),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "time_zone" && sortedInfo.order,
      },
      {
        dataIndex: "site_type",
        key: "site_type",
        title: this.props.i18n.t("Site Type"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "site_type" && sortedInfo.order,
      },
      {
        dataIndex: "consent_workflow_type_readable",
        key: "consent_workflow_type_readable",
        title: this.props.i18n.t("Consent"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "consent_workflow_type_readable" &&
          sortedInfo.order,
      },
      // {
      //   dataIndex: "fridge",
      //   key: "fridge",
      //   title: this.props.i18n.t('NamespaceSettingsSites:Fridge'),
      //   render: val => (<span>{get(val, 'name')}</span>),
      //   sorter: true,
      //   sortOrder: get(sortedInfo, 'columnKey') === 'fridge' && sortedInfo.order,
      // },
      {
        dataIndex: "created",
        key: "created",
        title: this.props.i18n.t("NamespaceSettingsSites:Date Created"),
        render: (val, record) => (
          <span>
            {moment
              .utc(val)
              .tz(this.props.userTimezone || get(record, "time_zone") || "UTC")
              .format("YYYY-MM-DD HH:mm")}{" "}
            {this.props.userShortTimezone || get(record, "short_tz") || "UTC"}
          </span>
        ),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "created" && sortedInfo.order,
      },
      {
        dataIndex: "id",
        key: "edit",
        title: this.props.i18n.t("Edit"),
        render: (val, site) => (
          <div className={classes.actions}>
            <Tooltip
              placement="topLeft"
              title={this.props.i18n.t("NamespaceSettingsSites:Edit Site")}
            >
              <Icon
                type="edit"
                theme="filled"
                className={classes.actionIcon}
                onClick={this.onSiteEdit(site)}
              />
            </Tooltip>
          </div>
        ),
      },
      {
        dataIndex: "id",
        key: "state",
        title: this.props.i18n.t("NamespaceSettingsSites:Site Created"),
        render: (val, site) => (
          <div className={classes.actions}>
            <Tooltip
              placement="topLeft"
              title={this.props.i18n.t(
                "NamespaceSettingsSites:Enable / Disable Site"
              )}
            >
              <Switch
                disabled={
                  (site.state === "active" &&
                    !this.props.siteDeletePermission) ||
                  (site.state === "inactive" &&
                    !this.props.siteUpdatePermission)
                }
                className={classes.activateBtn}
                checked={site.state === "active"}
                onChange={this.onSwitchSiteActivation(site.code, site.state)}
              />
            </Tooltip>
          </div>
        ),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "state" && sortedInfo.order,
      },
      {
        dataIndex: "id",
        key: "randomization_permitted",
        title: this.props.i18n.t("NamespaceSettingsSites:Randomization Active"),
        render: (val, site) => (
          <div className={classes.actions}>
            {site.site_type === "randomization" && (
              <Tooltip
                placement="topLeft"
                title={this.props.i18n.t(
                  "NamespaceSettingsSites:Activate / De-activate Site Randomization"
                )}
              >
                <Switch
                  disabled={
                    (site.randomization_permitted &&
                      !this.props.siteDeletePermission) ||
                    (!site.randomization_permitted &&
                      !this.props.siteUpdatePermission) ||
                    site.state === "inactive"
                  }
                  className={classes.activateBtn}
                  checked={site.randomization_permitted}
                  onChange={this.onSwitchSiteRandomization(
                    site.code,
                    site.randomization_permitted
                  )}
                />
              </Tooltip>
            )}
          </div>
        ),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "randomization_permitted" &&
          sortedInfo.order,
      },
      {
        dataIndex: "id",
        key: "consent_active",
        title: this.props.i18n.t("NamespaceSettingsSites:Consent active"),
        render: (val, site) => (
          <div className={classes.actions}>
            {site.site_type === "randomization" && (
              <Tooltip
                placement="topLeft"
                title={this.props.i18n.t(
                  "NamespaceSettingsSites:Activate / De-activate Consent Active"
                )}
              >
                <Switch
                  disabled={
                    (site.consent_active &&
                      !this.props.siteDeletePermission) ||
                    (!site.consent_active &&
                      !this.props.siteUpdatePermission) ||
                    site.state === "inactive"
                  }
                  className={classes.activateBtn}
                  checked={site.consent_active}
                  onChange={this.onSwitchConsentSiteSpecificActivation(
                    site.code,
                    site.consent_active
                  )}
                />
              </Tooltip>
            )}
          </div>
        ),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "consent_active" &&
          sortedInfo.order,
      },
    ];

    if (isDrugManagementActive) {
      let spliceColumn = 6;
      if (activeDrugSiteTypes.includes("manufacturer")) {
        columns.splice(spliceColumn, 0, {
          dataIndex: "manufacturer",
          key: "manufacturer",
          title: this.props.i18n.t("NamespaceSettingsSites:Manufacturer"),
          render: (val) => <span>{get(val, "name")}</span>,
          sorter: true,
          sortOrder:
            get(sortedInfo, "columnKey") === "manufacturer" && sortedInfo.order,
        });
        spliceColumn += 1;
      }

      if (activeDrugSiteTypes.includes("depot")) {
        columns.splice(spliceColumn, 0, {
          dataIndex: "storage",
          key: "storage",
          title: this.props.i18n.t("NamespaceSettingsSites:Depot"),
          render: (val) => <span>{get(val, "name")}</span>,
          sorter: true,
          sortOrder:
            get(sortedInfo, "columnKey") === "storage" && sortedInfo.order,
        });
        spliceColumn += 1;
      }

      if (activeDrugSiteTypes.includes("pharmacy")) {
        columns.splice(spliceColumn, 0, {
          dataIndex: "pharmacy",
          key: "pharmacy",
          title: this.props.i18n.t("NamespaceSettingsSites:Pharmacy"),
          render: (val) => <span>{get(val, "name")}</span>,
          sorter: true,
          sortOrder:
            get(sortedInfo, "columnKey") === "pharmacy" && sortedInfo.order,
        });
        spliceColumn += 1;
      }

      if (activeDrugSiteTypes.includes("fridge") && !activeDrugSiteTypes.includes("pharmacy")) {
        columns.splice(spliceColumn, 0, {
          dataIndex: "fridge",
          key: "fridge",
          title: this.props.i18n.t("NamespaceSettingsSites:Fridge"),
          render: (val) => <span>{get(val, "name")}</span>,
          sorter: true,
          sortOrder:
            get(sortedInfo, "columnKey") === "fridge" && sortedInfo.order,
        });
        spliceColumn += 1;
      }
    }

    return (
      <div>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("NamespaceSettingsSites:Site Management")}
            </h3>

            <Breadcrumb>
              <Breadcrumb.Item href="/admin/settings">
                {this.props.i18n.t("Admin Settings")}
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {this.props.i18n.t("NamespaceSettingsSites:Site Management")}
              </Breadcrumb.Item>
            </Breadcrumb>
            <br />

            <div className={classes.searchWrapper}>
              <label className={classes.searchWrapperSearch}>
                <b className={classes.searchWrapperLabel}>
                  {this.props.i18n.t("SEARCH")}
                </b>
                <Search
                  placeholder={this.props.i18n.t(
                    "NamespaceSettingsSites:By site name"
                  )}
                  enterButton={this.props.i18n.t("Search")}
                  size="large"
                  onSearch={this.onNameSearch}
                  value={nameSearch}
                  onChange={(e) =>
                    this.setState({ nameSearch: e.target.value })
                  }
                  style={{ maxWidth: "500px" }}
                />
              </label>

              <span
                className={classes.clearButton}
                onClick={() => this.onNameSearch("")}
              >
                {this.props.i18n.t("Clear")}
              </span>
            </div>

            <div className={classes.searchWrapperFilter}>
              <label className={classes.searchWrapperFilterItem}>
                <b className={classes.searchWrapperLabel}>
                  {this.props.i18n.t("Filter by")}
                </b>
                <Select
                  onChange={this.handleFilterChange}
                  value={filter}
                  style={{ width: "100%" }}
                  placeholder={this.props.i18n.t("Select")}
                >
                  <Option value="user">{this.props.i18n.t("User")}</Option>
                  <Option value="site_type">
                    {this.props.i18n.t("Site type")}
                  </Option>
                </Select>
              </label>

              {filter === "user" && (
                <label className={classes.searchWrapperFilterItem}>
                  <b className={classes.searchWrapperLabel}>
                    {this.props.i18n.t("User")}
                  </b>
                  <Select
                    onChange={this.handleUserChange}
                    value={user}
                    style={{ width: "100%" }}
                    placeholder={this.props.i18n.t("Select")}
                  >
                    {users.map((user) => (
                      <Option key={user.id} value={user.id}>
                        {user.username}
                      </Option>
                    ))}
                    <Option value="">
                      {this.props.i18n.t("NamespaceSettingsSites:All Users")}
                    </Option>
                  </Select>
                </label>
              )}

              {filter === "site_type" && (
                <label className={classes.searchWrapperFilterItem}>
                  <b className={classes.searchWrapperLabel}>
                    {this.props.i18n.t("Site type")}
                  </b>
                  <Select
                    onChange={this.handleSiteTypeChange}
                    value={siteType}
                    style={{ width: "100%" }}
                    placeholder={this.props.i18n.t("Select")}
                  >
                    <Option value="central">
                      {this.props.i18n.t("NamespaceSettingsSites:Central")}
                    </Option>
                    <Option value="randomization">
                      {this.props.i18n.t("Randomization")}
                    </Option>
                    <Option value="central_pharmacy">
                      {this.props.i18n.t(
                        "NamespaceSettingsSites:Central pharmacy"
                      )}
                    </Option>
                    <Option value="manufacturer">
                      {this.props.i18n.t("NamespaceSettingsSites:Manufacturer")}
                    </Option>
                    <Option value="pharmacy">
                      {this.props.i18n.t("NamespaceSettingsSites:Pharmacy")}
                    </Option>
                    <Option value="fridge">
                      {this.props.i18n.t("NamespaceSettingsSites:Fridge")}
                    </Option>
                    <Option value="depot">
                      {this.props.i18n.t("NamespaceSettingsSites:Depot")}
                    </Option>
                    <Option value="">{this.props.i18n.t("All sites")}</Option>
                  </Select>
                </label>
              )}

              <span className={classes.clearButton} onClick={this.clearFilters}>
                {this.props.i18n.t("Clear")}
              </span>
            </div>

            {errorMessage && <Alert type="error" message={errorMessage} />}

            {responseMessage && (
              <Alert type="success" message={responseMessage} />
            )}

            <div className={classes.tableWrapper}>
              <Table
                columns={columns}
                dataSource={sitesList}
                loading={isLoading}
                rowKey="id"
                pagination={false}
                onChange={this.handleTableChange}
              />
            </div>

            <br />

            {siteCreatePermission && (
              <Button type="primary" onClick={this.addSite}>
                {this.props.i18n.t("Add site")}
              </Button>
            )}

            <Modal
              visible={!!siteEdit}
              onCancel={this.onSiteEditHide}
              footer={null}
            >
              {siteEdit && (
                <SettingsSiteForm
                  {...siteEdit}
                  consentSettings={this.state.consentSettings}
                  manufacturerSites={manufacturerSites}
                  pharmacySites={pharmacySites}
                  depotSites={depotSites}
                  fridgeSites={fridgeSites}
                  isNew={siteEdit && !siteEdit.id}
                  onSubmit={this.onSiteEditSubmit}
                  onCancel={this.onSiteEditHide}
                />
              )}
            </Modal>
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  isDrugManagementActive: getDrugManagementStatus(state),
  activeDrugSiteTypes: getActiveDrugSiteTypes(state),
  siteCreatePermission: getSiteCreatePermission(state),
  siteDeletePermission: getSiteDeletePermission(state),
  siteUpdatePermission: getSiteUpdatePermission(state),
});

const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(SettingsSites))
);



// WEBPACK FOOTER //
// ./src/containers/SettingsSites/SettingsSites.js